import React from "react";
import { Badge, BadgeProps } from "../badge/badge";
import "./BadgeGroup.scss";

export type BadgeItem = Omit<BadgeProps, "size" | "className" | "showTooltip">;

interface BadgeGroupProps {
  badges: BadgeItem[];
  maxVisible?: number;
  size?: "small" | "medium" | "large";
  className?: string;
  onOverflowClick?: (hiddenBadges: BadgeItem[]) => void;
  showOverflowTooltip?: boolean;
  showBadgeTooltips?: boolean;
}

export const BadgeGroup: React.FC<BadgeGroupProps> = ({
  badges,
  maxVisible = 2,
  size = "medium",
  className = "",
  onOverflowClick,
  showOverflowTooltip = true,
  showBadgeTooltips = true,
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  const visibleBadges = badges.slice(0, maxVisible);
  const hiddenBadges = badges.slice(maxVisible);
  const overflowCount = hiddenBadges.length;

  const handleOverflowClick = () => {
    onOverflowClick?.(hiddenBadges);
  };

  const tooltipText = hiddenBadges.map((b) => b.text).join(", ");

  return (
    <div className={`badge-group badge-group-${size} ${className}`}>
      {visibleBadges.map((badge, index) => (
        <Badge key={index} {...badge} size={size} showTooltip={showBadgeTooltips} />
      ))}
      {overflowCount > 0 && (
        <span
          className={`badge-group-overflow ${onOverflowClick ? "badge-group-overflow-clickable" : ""}`}
          onClick={onOverflowClick ? handleOverflowClick : undefined}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          + {overflowCount}more
          {showOverflowTooltip && showTooltip && (
            <span className="badge-group-tooltip">{tooltipText}</span>
          )}
        </span>
      )}
    </div>
  );
};

